/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import MetaTags from 'react-meta-tags';

function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

async function goSleep() {
	for (let i = 0; i < 5; i++) {

		await sleep(i * 1000);
	}
	// window.location.reload();
}
function PersonalInformationProtection(props) {
	if (props.data !== null || props.data !== ""){
		var info = props.data
		if (props.data.includes("@")){
			var secComponentData = props.data.split("@")[1]
			var thirdComponentData = secComponentData.split(".")[1]
			return props.data.substring(0,2) + "***@" + secComponentData.substring(0,1) + "***." +  thirdComponentData
		}else if (/^\d+$/.test(props.data)){                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
			if (info.length === 10){
				return info.substring(0,4) + "*" + info.substring(5,6) + "*" + info.substring(7,8) + "*" + info.substring(9,10)
			}
		}else if (props.data.toString().match(/[\u3400-\u9FBF]/)){

			var result = ""
			for (let i=0; i < info.length; i++){
				if (i===0 || i === info.length-1){
					result += info[i] 
				}else{
					result += "o"
				}
					
			}
			return result
		}else {
			return info
		}
	}else{
		return <></>
	}
}
function MemberInfoModify() {

	const cookies = new Cookies();      // ＡＰＩ用access_token存取
	const access_token = cookies.get("auth_access_token");
	const userInfo = cookies.get("userInfo");
	const [showDialog, setShowDialog] = useState(false);
	let navigate = useNavigate();


	const [userInfoItem, setUserInfo] = useState(userInfo);
	const [matches390Min, setMatches390Min] = useState(
		window.matchMedia("(min-width: 391px)").matches
	)
	const [matches390Max, setMatches390Max] = useState(
		window.matchMedia("(max-width: 390px)").matches
	)
	useEffect(() => {

		if (cookies.get("auth_access_token") === undefined || cookies.get("auth_access_token") === "") {
			setShowDialog(true);
		}
		if (cookies.get("auth_access_token") !== undefined && userInfo === undefined) {
			goSleep();

		}
		window
			.matchMedia("(min-width: 391px)")
			.addEventListener('change', e => setMatches390Min(e.matches));
		window
			.matchMedia("(max-width: 390px)")
			.addEventListener('change', e => setMatches390Max(e.matches));

	}, [])
	return (
		<>
			<MetaTags>
				<title>中華電信AI語意雲延伸應用-會員中心-會員資料</title>
				<meta name="keywords" content="i寶貝會員中心,會員資料,帳號、密碼修改,會員電話、email修改"></meta>
				<meta name="description" content="提供會員方便的服務查詢管理，包含：個人資料維護、帳密修改等。" />
				<meta property="og:title" content="中華電信AI語意雲延伸應用-會員中心-會員資料" />
				<meta property="og:Description" content="提供會員方便的服務查詢管理，包含：個人資料維護、帳密修改等。" />
				<meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_d491a04b-9662-439d-a287-934eabb746a0.jpg" />
			</MetaTags>
			<Modal show={showDialog} onHide={() => setShowDialog(false)}>
				<Modal.Header closeButton>
					<Modal.Title>請先登入</Modal.Title>
				</Modal.Header>
				<Modal.Body>登入後才可查看會員資料</Modal.Body>
				<Modal.Footer>

					<Button variant="primary" onClick={() => { navigate("/login", { state: { lastPage: "/container/member_info", paramObj: {} } }); }}>
						確認
					</Button>
				</Modal.Footer>
			</Modal>
			{userInfoItem ?
				<div className="content_inpage">
					<div className="pagesize">

						<ul className="bread">
							<li><a href="index.html">首頁</a></li>
							<li><a href="commodity_01_01.html">會員中心</a></li>
						</ul>
						<div className="tab_con">
							<div className="tab_box active">

								<h2 className="tit_main">會員中心-會員資料</h2>

								<div className="content_box commodity_box">
									{matches390Min && (
										<div className="table_box">
											<table border="0" cellPadding="0" cellSpacing="0">
												<tbody>
													<tr>
														<th className="sty01">會員編號</th>
														<td><PersonalInformationProtection data={userInfoItem.userName}/></td>
													</tr>
													<tr>
														<th width="20%">姓名</th>
														<th width="30%">聯絡電話</th>
														<th width="30%">e-mail</th>
														<th width="20%">變更</th>
													</tr>
													<tr>
														<td width="20%"><PersonalInformationProtection data={userInfoItem.userName}/></td>
														<td width="30%"><PersonalInformationProtection data={userInfoItem.userPhone}/></td>
														<td width="30%"><PersonalInformationProtection data={userInfoItem.userEmail}/></td>
														<td width="20%"><span style={{ color: "#374d58", fontWeight: "700", textDecoration: "underline", cursor: "pointer" }} onClick={() => window.open("https://member.cht.com.tw/mysettings/contact_info")}>變更</span></td>
													</tr>
													<tr>
														<th className="sty01">手機修改</th>
														<td colSpan={4}>
															為確保您個人資料的安全，如欲修改手機需要進行<span style={{ color: "#374d58", fontWeight: "700", textDecoration: "underline", cursor: "pointer" }} onClick={() => window.open("https://member.cht.com.tw/mysettings/contact_info")}>身份認證</span>
														</td>
													</tr>

													<tr>
														<th className="sty01">密碼修改</th>
														<td colSpan={4}>為確保您個人資料的安全，如欲修改密碼及安全性需要進行<span style={{ color: "#374d58", fontWeight: "700", textDecoration: "underline", cursor: "pointer" }} onClick={() => window.open("https://member.cht.com.tw/mysettings/update_password")}>身份認證</span></td>
													</tr>

												</tbody>
											</table>

										</div>
									)}
									{matches390Max && (
										<div className="table_box">
											<table border="0" cellPadding="0" cellSpacing="0">
												<tbody>
													<tr>
														<th className="sty01">會員編號</th>
														<td>{userInfoItem.userName}</td>
													</tr>
													<tr>
														<th width="20%">姓名</th>
														<td width="20%">{userInfoItem.userName}</td>



													</tr>
													<tr>
														<th width="30%">聯絡電話</th>
														<td width="30%">{userInfoItem.userPhone}</td>


													</tr>
													<tr>
														<th width="30%">e-mail</th>
														<td width="30%">{userInfoItem.userEmail}</td>
													</tr>
													<tr>
														<th width="20%">變更</th>
														<td width="20%"><span style={{ color: "#374d58", fontWeight: "700", textDecoration: "underline", cursor: "pointer" }} onClick={() => window.open("https://member.cht.com.tw/mysettings/contact_info")}>變更</span></td>
													</tr>
													<tr>
														<th className="sty01">手機修改</th>
														<td colSpan={4}>
															為確保您個人資料的安全，如欲修改手機需要進行<span style={{ color: "#374d58", fontWeight: "700", textDecoration: "underline", cursor: "pointer" }} onClick={() => window.open("https://member.cht.com.tw/mysettings/contact_info")}>身份認證</span>
														</td>
													</tr>

													<tr>
														<th className="sty01">密碼修改</th>
														<td colSpan={4}>為確保您個人資料的安全，如欲修改密碼及安全性需要進行<span style={{ color: "#374d58", fontWeight: "700", textDecoration: "underline", cursor: "pointer" }} onClick={() => window.open("https://member.cht.com.tw/mysettings/update_password")}>身份認證</span></td>
													</tr>

												</tbody>
											</table>

										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				: <></>}
		</>
	)
}

export default MemberInfoModify;